import { http } from 'utils/http';
import { SignalingSocket, SignalingTokenResponse } from 'services/signaling';
import { ExportQuestionsParams } from 'features/qa/types';

export const exportQuestionsService = async (roomId: string, params?: ExportQuestionsParams) => {
  const { token } = await SignalingSocket.sendAsync<SignalingTokenResponse>({
    event: 'requestDownloadToken',
    data: {
      type: 'questions',
    },
  });

  const queryParams = new URLSearchParams();
  queryParams.set('format', 'txt/json');

  if (params?.filter) {
    queryParams.set('filter', params.filter);
  }

  if (params?.sortBy) {
    queryParams.set('sortBy', params.sortBy);
  }

  if (params?.order) {
    queryParams.set('order', params.order);
  }

  return http.get<Blob>(`/room-api/${roomId}/questions/export?${queryParams.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  });
};
